import { Layout, Spin } from "antd";
import { Toast } from "primereact/toast";
import React, { lazy, Suspense, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import Loader from "../components/Loader";
import RatingComp from "../components/Rating";
import { mock } from "../services";
import AppLayout from "./appLayout/AppLayout";
import LayoutWrapper from "./Layout.style";

const Login = lazy(() => import("../pages/Login"));
const SSOLogin = lazy(() => import("../pages/SSOLogin"));
const Signup = lazy(() => import("../pages/Signup"));
const ForgetPassword = lazy(() => import("../pages/ForgetPassword"));
const Profile = lazy(() => import("../pages/Profile"));
const Home = lazy(() => import("../pages/Home"));
const Realty = lazy(() => import("../pages/MyProperties"));
const OldProperty = lazy(() => import("../pages/MyApplications"));
const NewProperty = lazy(() => import("../pages/NewMyApplications"));
const ServicesHome = lazy(() =>
  import("../pages/GovernmentServices/ServicesHome")
);

const GovernmentServices = lazy(() => import("../pages/GovernmentServices"));

const OldQuickServices = lazy(() =>
  import("../pages/GovernmentServices/QuickServices")
);
const NewQuickServices = lazy(() =>
  import("../pages/GovernmentServices/NewQuickServices")
);

// Quick Services

const OldLandPlanning = lazy(() =>
  import("../pages/GovernmentServices/QuickServices/Services/LandPlanning")
);
const OldLandPlanningDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/LandPlanning/ServiceDescription"
  )
);
const OldLandPlanningRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/LandPlanning/ServiceRequirement"
  )
);
const NewLandPlanning = lazy(() =>
  import("../pages/GovernmentServices/NewQuickServices/Services/LandPlanning")
);
const NewLandPlanningDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/LandPlanning/ServiceDescription"
  )
);
const NewLandPlanningRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/LandPlanning/ServiceRequirement"
  )
);

const OldRegisteredPropertyAuthorization = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredPropertyAuthorization"
  )
);
const OldRegisteredPropertyAuthorizationDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredPropertyAuthorization/ServiceDescription"
  )
);
const OldRegisteredPropertyAuthorizationRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredPropertyAuthorization/ServiceRequirement"
  )
);
const NewRegisteredPropertyAuthorization = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredPropertyAuthorization"
  )
);
const NewRegisteredPropertyAuthorizationDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredPropertyAuthorization/ServiceDescription"
  )
);
const NewRegisteredPropertyAuthorizationRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredPropertyAuthorization/ServiceRequirement"
  )
);

// const ChangeStatement = lazy(() => import("../pages/GovernmentServices/NewQuickServices/Services/ChangeStatement"));
const OldChangeStatementService = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/ChangeStatementService"
  )
);
const OldChangeStatementServiceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/ChangeStatementService/ServiceDescription"
  )
);
const OldChangeStatementServiceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/ChangeStatementService/ServiceRequirement"
  )
);
const NewChangeStatementService = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/ChangeStatementService"
  )
);
const NewChangeStatementServiceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/ChangeStatementService/ServiceDescription"
  )
);
const NewChangeStatementServiceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/ChangeStatementService/ServiceRequirement"
  )
);
// const ChangeStatementDescription = lazy(() => import("../pages/GovernmentServices/NewQuickServices/Services/ChangeStatement/ServiceDescription"));
// const ChangeStatementRequirements = lazy(() => import("../pages/GovernmentServices/NewQuickServices/Services/ChangeStatement/ServiceRequirement"));

const OldNoPropertiesCert = lazy(() =>
  import("../pages/GovernmentServices/QuickServices/Services/NoPropertiesCert")
);
const OldNoPropertiesCertDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/NoPropertiesCert/ServiceDescription"
  )
);
const OldNoPropertiesCertRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/NoPropertiesCert/ServiceRequirement"
  )
);
const NewNoPropertiesCert = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/NoPropertiesCert"
  )
);
const NewNoPropertiesCertDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/NoPropertiesCert/ServiceDescription"
  )
);
const NewNoPropertiesCertRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/NoPropertiesCert/ServiceRequirement"
  )
);

const OldPropertyDisclosure = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/PropertyDisclosure"
  )
);
const OldPropertyDisclosureDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/PropertyDisclosure/ServiceDescription"
  )
);
const OldPropertyDisclosureRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/PropertyDisclosure/ServiceRequirement"
  )
);
const NewPropertyDisclosure = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/PropertyDisclosure"
  )
);
const NewPropertyDisclosureDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/PropertyDisclosure/ServiceDescription"
  )
);
const NewPropertyDisclosureRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/PropertyDisclosure/ServiceRequirement"
  )
);

const ProvideLandCoordinates = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/ProvideLandCoordinates"
  )
);

const NewRegisteredProperty = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredProperty"
  )
);
const NewRegisteredPropertyDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredProperty/ServiceDescription"
  )
);
const NewRegisteredPropertyRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/RegisteredProperty/ServiceRequirement"
  )
);
const OldRegisteredProperty = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredProperty"
  )
);
const OldRegisteredPropertyDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredProperty/ServiceDescription"
  )
);
const OldRegisteredPropertyRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/RegisteredProperty/ServiceRequirement"
  )
);

const OldQushanAgencies = lazy(() =>
  import("../pages/GovernmentServices/QuickServices/Services/QushanAgencies")
);
const OldQushanAgenciesDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/QushanAgencies/ServiceDescription"
  )
);
const OldQushanAgenciesRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/QuickServices/Services/QushanAgencies/ServiceRequirement"
  )
);
const NewQushanAgencies = lazy(() =>
  import("../pages/GovernmentServices/NewQuickServices/Services/QushanAgencies")
);
const NewQushanAgenciesDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/QushanAgencies/ServiceDescription"
  )
);
const NewQushanAgenciesRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/NewQuickServices/Services/QushanAgencies/ServiceRequirement"
  )
);

// Ownership Transfer

const RealtySelling = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/Selling")
);
const RealtySellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/About/ServiceDescription"
  )
);
const RealtySellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/About/ServiceRequirements"
  )
);

// const InstallmentSelling = lazy(() => import("../pages/GovernmentServices/OwnershipTransfer/Selling"));
const InstallmentSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/AboutInstallment/ServiceDescription"
  )
);
const InstallmentSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/AboutInstallment/ServiceRequirements"
  )
);

const PromiseToSellDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/AboutPromiseToSell/ServiceDescription"
  )
);
const PromiseToSellRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Selling/AboutPromiseToSell/ServiceRequirements"
  )
);

const ReregisterCourtsSelling = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReregisterCourtsSelling"
  )
);
const ReregisterDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReregisterCourtsSelling/About/ServiceDescription"
  )
);
const ReregisterRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReregisterCourtsSelling/About/ServiceRequirements"
  )
);

const CourtsSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReregisterCourtsSelling/AboutCourtsSelling/ServiceDescription"
  )
);
const CourtsSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReregisterCourtsSelling/AboutCourtsSelling/ServiceRequirements"
  )
);

const SellingWithMortgage = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/SellingWithMortgage")
);
const SellingWithMortgageDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SellingWithMortgage/About/ServiceDescription"
  )
);
const SellingWithMortgageRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SellingWithMortgage/About/ServiceRequirements"
  )
);

const AgencyAccreditation = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/Agency")
);
const AgencyAccreditationDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Agency/About/ServiceDescription"
  )
);
const AgencyAccreditationRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Agency/About/ServiceRequirements"
  )
);

const FinanceLease = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Documentation"
  )
);
const FinanceLeaseDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Documentation/About/ServiceDescription"
  )
);
const FinanceLeaseRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Documentation/About/ServiceRequirements"
  )
);
const FinanceLeaseDoc = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/DocumentationNew"
  )
);
const FinanceLeaseDocDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/DocumentationNew/About/ServiceDescription"
  )
);
const FinanceLeaseDocRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/DocumentationNew/About/ServiceRequirements"
  )
);

const FinanceLeaseReplace = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Replace")
);
const FinanceLeaseReplaceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Replace/About/ServiceDescription"
  )
);
const FinanceLeaseReplaceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Replace/About/ServiceRequirements"
  )
);
const FinanceLeaseLandLordReplaceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Replace/AboutLandLord/ServiceDescription"
  )
);
const FinanceLeaseLandLordReplaceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Replace/AboutLandLord/ServiceRequirements"
  )
);

const FinanceLeaseCencel = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Cancel")
);
const FinanceLeaseCencelDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Cancel/About/ServiceDescription"
  )
);
const FinanceLeaseCencelRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Cancel/About/ServiceRequirements"
  )
);

const FinanceLeaseSelling = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Selling")
);
const FinanceLeaseSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Selling/About/ServiceDescription"
  )
);
const FinanceLeaseSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/FinanceLease/Selling/About/ServiceRequirements"
  )
);

const TransmissionTakharog = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/Transmission")
);

const TransmissionDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/AboutTransmission/ServiceDescription"
  )
);
const TransmissionRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/AboutTransmission/ServiceRequirements"
  )
);

const TakharogDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/AboutTakharog/ServiceDescription"
  )
);
const TakharogRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/AboutTakharog/ServiceRequirements"
  )
);

const TransmissionDeceasedAgentDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/registrationOfDeceasedAgentAbout/ServiceDescription"
  )
);
const TransmissionDeceasedAgentRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Transmission/registrationOfDeceasedAgentAbout/ServiceRequirements"
  )
);

const WillDocumentation = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/WillDocumentation")
);
const WillDocumentationDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/WillDocumentation/About/ServiceDescription"
  )
);
const WillDocumentationRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/WillDocumentation/About/ServiceRequirements"
  )
);

const SetLimits = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/SetLimits")
);
const SetLimitsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/About/ServiceDescription"
  )
);
const SetLimitsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/About/ServiceRequirements"
  )
);

const DemarcationSettlementLandDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/DemarcationSettlementLandAbout/ServiceDescription"
  )
);
const DemarcationSettlementLandRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/DemarcationSettlementLandAbout/ServiceRequirements"
  )
);

const ReplacementSettlementRoadDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/ReplacementSettlementRoadAbout/ServiceDescription"
  )
);
const ReplacementSettlementRoadRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/ReplacementSettlementRoadAbout/ServiceRequirements"
  )
);

const CancellationSettlementLandDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/CancellationSettlementLandAbout/ServiceDescription"
  )
);
const CancellationSettlementLandRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/CancellationSettlementLandAbout/ServiceRequirements"
  )
);

const ProvidingInfoOwnedPropertyDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/ProvidingInfoOwnedPropertyAbout/ServiceDescription"
  )
);
const ProvidingInfoOwnedPropertyRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/SetLimits/ProvidingInfoOwnedPropertyAbout/ServiceRequirements"
  )
);

const ChangeStatementRequest = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ChangeStatementRequest")
);
const ChangeStatementRequestDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChangeStatementRequest/About/ServiceDescription"
  )
);
const ChangeStatementRequestRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChangeStatementRequest/About/ServiceRequirements"
  )
);

const ProvidingMapsPanelsAndIndexes = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ProvidingMapsPanelsAndIndexes"
  )
);
const ProvidingMapsPanelsAndIndexesDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ProvidingMapsPanelsAndIndexes/About/ServiceDescription"
  )
);
const ProvidingMapsPanelsAndIndexesRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ProvidingMapsPanelsAndIndexes/About/ServiceRequirements"
  )
);

const ChannelDemarcation = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation")
);
const ChannelDemarcationDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation/About/ServiceDescription"
  )
);
const ChannelDemarcationRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation/About/ServiceRequirements"
  )
);

const CertifiedCopyoftheBorderFixingDetectionReport = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation")
);
const CertifiedCopyoftheBorderFixingDetectionReportDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation/AboutCertifiedCopyoftheBorderFixingDetectionReport/ServiceDescription"
  )
);
const CertifiedCopyoftheBorderFixingDetectionReportRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ChannelDemarcation/AboutCertifiedCopyoftheBorderFixingDetectionReport/ServiceRequirements"
  )
);
const CorrectServeyInfo = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo")
);
const CorrectServeyInfoDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo/About/ServiceDescription"
  )
);
const CorrectServeyInfoRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo/About/ServiceRequirements"
  )
);
const CollectingPropertiesImproveAppearance = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo")
);
const CollectingPropertiesImproveAppearanceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo/AboutCollectingPropertiesImproveAppearance/ServiceDescription"
  )
);
const CollectingPropertiesImproveAppearanceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/CorrectServeyInfo/AboutCollectingPropertiesImproveAppearance/ServiceRequirements"
  )
);

const RefundFees = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/RefundFees")
);
const RefundFeesDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/RefundFees/About/ServiceDescription"
  )
);
const RefundFeesRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/RefundFees/About/ServiceRequirements"
  )
);
const ReconsiderAdministrativePrice = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReconsiderAdministrativePrice"
  )
);
const ReconsiderAdministrativePriceDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReconsiderAdministrativePrice/About/ServiceDescription"
  )
);
const ReconsiderAdministrativePriceRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReconsiderAdministrativePrice/About/ServiceRequirements"
  )
);

const ExecuteRetention = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ExecuteRetention")
);
const ExecuteRetentionDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ExecuteRetention/About/ServiceDescription"
  )
);
const ExecuteRetentionRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ExecuteRetention/About/ServiceRequirements"
  )
);

const ReleaseRetention = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ReleaseRetention")
);
const ReleaseRetentionDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReleaseRetention/About/ServiceDescription"
  )
);
const ReleaseRetentionRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ReleaseRetention/About/ServiceRequirements"
  )
);

const GuaranteeCertificate = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/GuaranteeCertificate")
);
const GuaranteeCertificateDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/GuaranteeCertificate/About/ServiceDescription"
  )
);
const GuaranteeCertificateRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/GuaranteeCertificate/About/ServiceRequirements"
  )
);

const ForeclosureSale = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/ForeclosureSale")
);
const ForeclosureSaleDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ForeclosureSale/About/ServiceDescription"
  )
);
const ForeclosureSaleRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/ForeclosureSale/About/ServiceRequirements"
  )
);

const Exchange = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/Exchange")
);
const ExchangeDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Exchange/About/ServiceDescription"
  )
);
const ExchangeRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Exchange/About/ServiceRequirements"
  )
);

const AuthForHousingPurposes = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes")
);
const AuthForHousingPurposesDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/About/ServiceDescription"
  )
);
const AuthForHousingPurposesRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/About/ServiceRequirements"
  )
);

const LeasingStateProperty = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/LeasingStateProperty"
  )
);
const LeasingStatePropertyDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/AboutLeasingStateProperty/ServiceDescription"
  )
);
const LeasingStatePropertyRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/AboutLeasingStateProperty/ServiceRequirements"
  )
);

const RentingStatePropertyDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/AboutRentingStateProperty/ServiceDescription"
  )
);
const RentingStatePropertyRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthForHousingPurposes/AboutRentingStateProperty/ServiceRequirements"
  )
);

const Endowment = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/Endowment")
);

const PublicEndowmentDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Endowment/AboutPublicEndowment/ServiceDescription"
  )
);
const PublicEndowmentRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Endowment/AboutPublicEndowment/ServiceRequirements"
  )
);

const RelativesEndowmentDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Endowment/AboutRelativesEndowment/ServiceDescription"
  )
);
const RelativesEndowmentRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/Endowment/AboutRelativesEndowment/ServiceRequirements"
  )
);

const AuthSelling = lazy(() =>
  import("../pages/GovernmentServices/OwnershipTransfer/AuthSelling")
);

const PetraSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutPetra/ServiceDescription"
  )
);
const PetraSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutPetra/ServiceRequirements"
  )
);

const AsezaSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutAseza/ServiceDescription"
  )
);
const AsezaSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutAseza/ServiceRequirements"
  )
);

const JVASellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutJVA/ServiceDescription"
  )
);
const JVASellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutJVA/ServiceRequirements"
  )
);

const UrbanDevSellingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutUrbanDev/ServiceDescription"
  )
);
const UrbanDevSellingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/OwnershipTransfer/AuthSelling/AboutUrbanDev/ServiceRequirements"
  )
);

// RSO

const RealEstateOfficeGrant = lazy(() =>
  import("../pages/GovernmentServices/RealEstateOffice/Grant")
);
const RealEstateOfficeGrantDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/Grant/RealEstateDescription"
  )
);
const RealEstateOfficeGrantRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/Grant/RealEstateRequirements"
  )
);

const RealEstateOfficeRenew = lazy(() =>
  import("../pages/GovernmentServices/RealEstateOffice/Renew")
);
const RealEstateOfficeRenewDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/Renew/RenewRealEstateDescription"
  )
);
const RealEstateOfficeRenewRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/Renew/ReNewRealEstateRequirements"
  )
);

const RealEstateOfficeSuspendCancel = lazy(() =>
  import("../pages/GovernmentServices/RealEstateOffice/SuspendCancel")
);
const RealEstateOfficeSuspendCancelDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/SuspendCancel/StopRealEstateDescription"
  )
);
const StopRealEstateRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateOffice/SuspendCancel/StopRealEstateRequirements"
  )
);

// EST

const RealEstateAppraiserGrant = lazy(() =>
  import("../pages/GovernmentServices/RealEstateAppraiser/Grant")
);
const RealEstateAppraiserGrantDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateAppraiser/Grant/AppraiserDescription"
  )
);
const RealEstateAppraiserGrantRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateAppraiser/Grant/AppraiserRequirements"
  )
);

const RealEstateAppraiserRenewSuspendCancel = lazy(() =>
  import("../pages/GovernmentServices/RealEstateAppraiser/RenewSuspendCancel")
);
const RealEstateAppraiserRenewSuspendCancelDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateAppraiser/RenewSuspendCancel/DeleteRenewAppraiserDescription"
  )
);
const RealEstateAppraiserRenewSuspendCancelRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RealEstateAppraiser/RenewSuspendCancel/DeleteRenewAppraiserRequirements"
  )
);

// SUV

const SurveyorGrant = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Grant")
);
const SurveyorGrantDescription = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Grant/ServeyorNewDescription")
);
const SurveyorGrantRequirements = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Grant/ServeyorNewRequirements")
);

const SurveyorRenew = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Renew")
);
const ServeyorRenewDescription = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Renew/ServeyorRenewDescription")
);
const ServeyorRenewRequirements = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/Renew/ServeyorRenewRequirements")
);

const SurveyorSuspendCancel = lazy(() =>
  import("../pages/GovernmentServices/Surveyor/SuspendCancel")
);
const SurveyorSuspendCancelDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Surveyor/SuspendCancel/ServeyorRemoveDescription"
  )
);

// Efraz

const EfrazPartnersSplitJudicial = lazy(() =>
  import("../pages/GovernmentServices/Efraz/PartnersSplitJudicial")
);

const EfrazPartnersLandsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutPartnerLands/ServiceDescription"
  )
);
const EfrazPartnersLandsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutPartnerLands/ServiceRequirements"
  )
);

const EfrazPartnersApartmentsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutPartnerApartments/ServiceDescription"
  )
);
const EfrazPartnersApartmentsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutPartnerApartments/ServiceRequirements"
  )
);

const EfrazSplitLandsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSplitLands/ServiceDescription"
  )
);
const EfrazSplitLandsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSplitLands/ServiceRequirements"
  )
);

const EfrazSplitApartmentsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSplitApartments/ServiceDescription"
  )
);
const EfrazSplitApartmentsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSplitApartments/ServiceRequirements"
  )
);

const EfrazJudicialLandsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutJudicialLands/ServiceDescription"
  )
);
const EfrazJudicialLandsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutJudicialLands/ServiceRequirements"
  )
);

const EfrazJudicialApartmentsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutJudicialApartments/ServiceDescription"
  )
);
const EfrazJudicialApartmentsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutJudicialApartments/ServiceRequirements"
  )
);

const EfrazTawheed = lazy(() =>
  import("../pages/GovernmentServices/Efraz/Tawheed")
);
const EfrazTawheedLandsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/Tawheed/AboutLands/ServiceDescription"
  )
);
const EfrazTawheedLandsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/Tawheed/AboutLands/ServiceRequirements"
  )
);
const EfrazTawheedApartmentsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/Tawheed/AboutApartments/ServiceDescription"
  )
);
const EfrazTawheedApartmentsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/Tawheed/AboutApartments/ServiceRequirements"
  )
);

const EfrazSellingLandsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSellingLands/ServiceDescription"
  )
);
const EfrazSellingLandsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSellingLands/ServiceRequirements"
  )
);

const EfrazSellingApartmentsDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSellingApartments/ServiceDescription"
  )
);
const EfrazSellingApartmentsRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Efraz/PartnersSplitJudicial/AboutSellingApartments/ServiceRequirements"
  )
);

// Mortgage

const Mortgage = lazy(() =>
  import("../pages/GovernmentServices/Mortgage/Mortgage")
);
const MortgageDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/Mortgage/About/ServiceDescription"
  )
);
const MortgageRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/Mortgage/About/ServiceRequirements"
  )
);

const MortgageRelease = lazy(() =>
  import("../pages/GovernmentServices/Mortgage/MortgageRelease")
);
const MortgageReleaseDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/MortgageRelease/About/ServiceDescription"
  )
);
const MortgageReleaseRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/MortgageRelease/About/ServiceRequirements"
  )
);

const MortgageTransfer = lazy(() =>
  import("../pages/GovernmentServices/Mortgage/MortgageTransfer")
);
const MortgageTransferDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/MortgageTransfer/About/ServiceDescription"
  )
);
const MortgageTransferRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/Mortgage/MortgageTransfer/About/ServiceRequirements"
  )
);
const Planting = lazy(() =>
  import("../pages/GovernmentServices/RegistrationServices/Planting")
);
const PlantingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/About/ServiceDescription"
  )
);
const PlantingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/About/ServiceRequirements"
  )
);
const CancelFarmLeasingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/CancelFarmLeasingAbout/ServiceDescription"
  )
);
const CancelFarmLeasingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/CancelFarmLeasingAbout/ServiceRequirements"
  )
);
const TransferFarmLeasingDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/TransferFarmLeasingAbout/ServiceDescription"
  )
);
const TransferFarmLeasingRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/TransferFarmLeasingAbout/ServiceRequirements"
  )
);
const CorrectNameNationalIdDescription = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/CorrectNameNationalIdAbout/ServiceDescription"
  )
);
const CorrectNameNationalIdRequirements = lazy(() =>
  import(
    "../pages/GovernmentServices/RegistrationServices/Planting/CorrectNameNationalIdAbout/ServiceRequirements"
  )
);

const PrivateRoute = () => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  return isLoggedIn ? (
    <Suspense fallback={<Spin className="py-4" spinning={true} />}>
      <Outlet />
    </Suspense>
  ) : (
    <Navigate to="/login" />
  );
};

const ApplicationLayout = () => {
  const isLoading = useSelector((state) => state.isLoading);
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const errorMessage = useSelector((state) => state.errorMessage);
  const successMessage = useSelector((state) => state.successMessage);
  const summaryMessage = useSelector((state) => state.summaryMessage);
  const sellingFormDetails = useSelector((state) => state.sellingFormDetails);

  const toast = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isLoading & !mock) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [isLoading]);

  useEffect(() => {
    if (errorMessage) {
      toast.current.show({
        severity: "error",
        summary: t("common.errorMessage"),
        detail: errorMessage,
        life: 15000,
        style: { direction: "rtl", whiteSpace: "pre-line" },
      });
    }
  }, [errorMessage, t]);

  useEffect(() => {
    if (successMessage) {
      toast.current.show({
        severity: "success",
        detail: summaryMessage,
        summary: successMessage,
        life: 4000,
        style: { direction: "rtl" },
      });
    }
  }, [successMessage, t]);

  const generalFallbackRoute = (
    <Route path="*" element={<Navigate to={""} />} />
  );

  const categoryFallbackRoute = (
    <>
      <Route
        path=""
        exact
        element={<Navigate to={"/government-services/dls"} />}
      />
      {generalFallbackRoute}
    </>
  );

  const serviceFallbackRoute = (
    <>
      <Route path="" exact element={<Navigate to={"apply"} />} />
      <Route path="*" element={<Navigate to={"apply"} />} />
    </>
  );

  return (
    <LayoutWrapper>
      <Toast dir="ltr" ref={toast} />
      {isLoading & !mock ? <Loader /> : ""}
      {isLoggedIn && <RatingComp />}
      <Layout>
        <Router>
          <Routes>
            <Route
              path="forget-password"
              element={
                isLoggedIn ? (
                  <Navigate to={"/home"} />
                ) : (
                  <Suspense
                    fallback={<Spin className="py-4" spinning={true} />}
                  >
                    <ForgetPassword />
                  </Suspense>
                )
              }
            />
            <Route
              path="login"
              element={
                isLoggedIn ? (
                  <Navigate to={"/home"} />
                ) : (
                  <Suspense
                    fallback={<Spin className="py-4" spinning={true} />}
                  >
                    <Login />
                  </Suspense>
                )
              }
            />
            <Route
              path="sso"
              element={
                isLoggedIn ? (
                  <Navigate to={"/home"} />
                ) : (
                  <Suspense
                    fallback={<Spin className="py-4" spinning={true} />}
                  >
                    <SSOLogin />
                  </Suspense>
                )
              }
            />
            <Route
              path="signup"
              element={
                // isLoggedIn ? (
                //   <Navigate to={"/home"} />
                // ) : (
                <Suspense fallback={<Spin className="py-4" spinning={true} />}>
                  <Signup />
                </Suspense>
                // )
              }
            />
            <Route path="" exact element={<PrivateRoute />}>
              <Route path="" element={<AppLayout />}>
                <Route
                  path=""
                  element={
                    isLoggedIn ? (
                      <Navigate to={"/home"} />
                    ) : (
                      <Navigate to={"/login"} />
                    )
                  }
                />

                <Route path="home" element={<Home />} />
                <Route path="profile" element={<Profile />} />

                <Route path="my-applications" element={<OldProperty />} />
                <Route path="my-applications-new" element={<NewProperty />} />

                <Route path="my-properties" element={<Realty />} />

                <Route path="government-services">
                  <Route path="" exact element={<ServicesHome />} />

                  <Route path="dls">
                    <Route path="" exact element={<OldQuickServices />} />
                    <Route path="new" exact element={<NewQuickServices />} />

                    {/* <Route path="quick-services" element={<GovernmentServices />}> */}
                    <Route path="quick-services">
                      {/* <Route path="land-planning">
                        <Route path="apply" element={<OldLandPlanning />} />

                        <Route
                          path="description"
                          element={<OldLandPlanningDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldLandPlanningRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="land-planning-new"> */}
                      <Route path="land-planning">
                        <Route path="apply" element={<NewLandPlanning />} />

                        <Route
                          path="description"
                          element={<NewLandPlanningDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewLandPlanningRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {/* <Route path="change-statement">
                        <Route path="apply" element={<ChangeStatement />} />

                        <Route path="description" element={<ChangeStatementDescription />} />

                        <Route path="requirements" element={<ChangeStatementRequirements />} />

                        {serviceFallbackRoute}
                      </Route> */}

                      {/* <Route path="no-properties">
                        <Route path="apply" element={<OldNoPropertiesCert />} />

                        <Route
                          path="description"
                          element={<OldNoPropertiesCertDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldNoPropertiesCertRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="no-properties-new"> */}
                      <Route path="no-properties">
                        <Route path="apply" element={<NewNoPropertiesCert />} />

                        <Route
                          path="description"
                          element={<NewNoPropertiesCertDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewNoPropertiesCertRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      {/* <Route path="registered-property-authorization">
                        <Route
                          path="apply"
                          element={<OldRegisteredPropertyAuthorization />}
                        />

                        <Route
                          path="description"
                          element={
                            <OldRegisteredPropertyAuthorizationDescription />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <OldRegisteredPropertyAuthorizationRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="registered-property-authorization-new"> */}
                      <Route path="registered-property-authorization">
                        <Route
                          path="apply"
                          // element={<NewRegisteredPropertyAuthorization />}
                          element={<NewRegisteredProperty agencies />}
                        />

                        <Route
                          path="description"
                          element={
                            <NewRegisteredPropertyAuthorizationDescription />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <NewRegisteredPropertyAuthorizationRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      {/* <Route path="change-statement">
                        <Route
                          path="apply"
                          element={<OldChangeStatementService />}
                        />

                        <Route
                          path="description"
                          element={<OldChangeStatementServiceDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldChangeStatementServiceRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="change-statement-new"> */}
                      <Route path="change-statement">
                        <Route
                          path="apply"
                          element={<NewChangeStatementService />}
                        />

                        <Route
                          path="description"
                          element={<NewChangeStatementServiceDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewChangeStatementServiceRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {/* <Route path="property-disclousre">
                        <Route
                          path="apply"
                          element={<OldPropertyDisclosure />}
                        />

                        <Route
                          path="description"
                          element={<OldPropertyDisclosureDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldPropertyDisclosureRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="property-disclousre-new"> */}
                      <Route path="property-disclousre">
                        <Route
                          path="apply"
                          element={<NewPropertyDisclosure />}
                        />

                        <Route
                          path="description"
                          element={<NewPropertyDisclosureDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewPropertyDisclosureRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {/* <Route path="registered-property">
                        <Route
                          path="apply"
                          element={<OldRegisteredProperty />}
                        />

                        <Route
                          path="description"
                          element={<OldRegisteredPropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldRegisteredPropertyRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="registered-property-new"> */}
                      <Route path="registered-property">
                        <Route
                          path="apply"
                          element={<NewRegisteredProperty />}
                        />

                        <Route
                          path="description"
                          element={<NewRegisteredPropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewRegisteredPropertyRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="provide-land-coordinates">
                        <Route path="apply" element={<ProvideLandCoordinates />} />

                        {/* <Route
                          path="description"
                          element={<RegisteredPropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RegisteredPropertyRequirements />}
                        /> */}

                        {serviceFallbackRoute}
                      </Route>

                      {/* <Route path="qushan-agencies">
                        <Route path="apply" element={<OldQushanAgencies />} />

                        <Route
                          path="description"
                          element={<OldQushanAgenciesDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<OldQushanAgenciesRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route> */}
                      {/* <Route path="qushan-agencies-new"> */}
                      <Route path="qushan-agencies">
                        <Route path="apply" element={<NewQushanAgencies />} />

                        <Route
                          path="description"
                          element={<NewQushanAgenciesDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<NewQushanAgenciesRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {categoryFallbackRoute}
                    </Route>

                    <Route path="registration-services">
                      <Route path="farm-leasing">
                        <Route
                          path="apply"
                          element={<Planting farmLeasing />}
                        />

                        <Route
                          path="description"
                          element={<PlantingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<PlantingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="cancel-farm-leasing">
                        <Route
                          path="apply"
                          element={<Planting cancelFarmLeasing />}
                        />

                        <Route
                          path="description"
                          element={<CancelFarmLeasingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<CancelFarmLeasingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="transfer-farm-leasing">
                        <Route
                          path="apply"
                          element={<Planting transferPlanting />}
                        />

                        <Route
                          path="description"
                          element={<TransferFarmLeasingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<TransferFarmLeasingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="correct-name-national-id">
                        <Route
                          path="apply"
                          element={<Planting correctNameNationalId />}
                        />

                        <Route
                          path="description"
                          element={<CorrectNameNationalIdDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<CorrectNameNationalIdRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                    </Route>

                    <Route path="ownership-transfer">
                      <Route path="selling">
                        <Route
                          path="apply-mine"
                          element={<RealtySelling selling isOwner={true} />}
                        />

                        <Route
                          path="apply"
                          element={<RealtySelling selling />}
                        />

                        <Route
                          path="description"
                          element={<RealtySellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RealtySellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="installment-selling">
                        <Route
                          path="apply-mine"
                          element={<RealtySelling installment isOwner={true} />}
                        />

                        <Route
                          path="apply"
                          element={<RealtySelling installment />}
                        />

                        <Route
                          path="description"
                          element={<InstallmentSellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<InstallmentSellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="promise-to-sell">
                        <Route
                          path="apply-mine"
                          element={
                            <RealtySelling promiseToSell isOwner={true} />
                          }
                        />

                        <Route
                          path="apply"
                          element={<RealtySelling promiseToSell />}
                        />

                        <Route
                          path="description"
                          element={<PromiseToSellDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<PromiseToSellRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="re-register">
                        <Route
                          path="apply-mine"
                          element={<ReregisterCourtsSelling isOwner={true} />}
                        />

                        <Route
                          path="apply"
                          element={<ReregisterCourtsSelling />}
                        />

                        <Route
                          path="description"
                          element={<ReregisterDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ReregisterRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="courts-selling">
                        <Route
                          path="apply-mine"
                          element={
                            <ReregisterCourtsSelling
                              courtsSelling
                              isOwner={true}
                            />
                          }
                        />

                        <Route
                          path="apply"
                          element={<ReregisterCourtsSelling courtsSelling />}
                        />

                        <Route
                          path="description"
                          element={<CourtsSellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<CourtsSellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="selling-with-mortgage">
                        <Route
                          path="apply-mine"
                          element={<SellingWithMortgage isOwner={true} />}
                        />

                        <Route path="apply" element={<SellingWithMortgage />} />

                        <Route
                          path="description"
                          element={<SellingWithMortgageDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<SellingWithMortgageRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="agency-accreditation">
                        <Route path="apply" element={<AgencyAccreditation />} />
                        <Route
                          path="edit"
                          element={<AgencyAccreditation edit />}
                        />

                        <Route
                          path="description"
                          element={<AgencyAccreditationDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<AgencyAccreditationRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="asezaSelling">
                        <Route
                          path="apply"
                          element={<AuthSelling auth="ASEZA" />}
                        />

                        <Route
                          path="description"
                          element={<AsezaSellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<AsezaSellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="jvaSelling">
                        <Route
                          path="apply"
                          element={<AuthSelling auth="JVA" />}
                        />

                        <Route
                          path="description"
                          element={<JVASellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<JVASellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="petraSelling">
                        <Route
                          path="apply"
                          element={<AuthSelling auth="PETRA" />}
                        />

                        <Route
                          path="description"
                          element={<PetraSellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<PetraSellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="urbanSelling">
                        <Route
                          path="apply"
                          element={<AuthSelling auth="URBANDEV" />}
                        />

                        <Route
                          path="description"
                          element={<UrbanDevSellingDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<UrbanDevSellingRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="transmission">
                        <Route
                          path="apply"
                          element={<TransmissionTakharog transmission />}
                        />

                        <Route
                          path="description"
                          element={<TransmissionDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<TransmissionRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="transmissionTakharog">
                        <Route
                          path="apply"
                          element={<TransmissionTakharog takharog />}
                        />

                        <Route
                          path="description"
                          element={<TakharogDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<TakharogRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="registration-of-deceased-agent">
                        <Route
                          path="apply"
                          element={<TransmissionTakharog deceasedAgent />}
                        />

                        <Route
                          path="description"
                          element={<TransmissionDeceasedAgentDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<TransmissionDeceasedAgentRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="will-documentation">
                        <Route path="apply" element={<WillDocumentation />} />

                        <Route
                          path="description"
                          element={<WillDocumentationDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<WillDocumentationRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="refund-of-collected-fees">
                        <Route path="apply" element={<RefundFees />} />

                        <Route
                          path="description"
                          element={<RefundFeesDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RefundFeesRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="reconsider-administrative-price">
                        <Route
                          path="apply"
                          element={<ReconsiderAdministrativePrice />}
                        />

                        <Route
                          path="description"
                          element={<ReconsiderAdministrativePriceDescription />}
                        />

                        <Route
                          path="requirements"
                          element={
                            <ReconsiderAdministrativePriceRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="execute-retention">
                        <Route path="apply" element={<ExecuteRetention />} />

                        <Route
                          path="description"
                          element={<ExecuteRetentionDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ExecuteRetentionRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="release-retention">
                        <Route path="apply" element={<ReleaseRetention />} />

                        <Route
                          path="description"
                          element={<ReleaseRetentionDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ReleaseRetentionRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="guarantee-certificate">
                        <Route
                          path="apply"
                          element={<GuaranteeCertificate />}
                        />

                        <Route
                          path="description"
                          element={<GuaranteeCertificateDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<GuaranteeCertificateRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="foreclosure-sale">
                        <Route path="apply" element={<ForeclosureSale />} />

                        <Route
                          path="description"
                          element={<ForeclosureSaleDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ForeclosureSaleRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="exchange">
                        <Route path="apply" element={<Exchange />} />

                        <Route
                          path="description"
                          element={<ExchangeDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ExchangeRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="authorization-service-for-housing-purposes">
                        <Route
                          path="apply"
                          element={<AuthForHousingPurposes />}
                        />

                        <Route
                          path="description"
                          element={<AuthForHousingPurposesDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<AuthForHousingPurposesRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="leasing-state-property-lands-within-frontier-centers">
                        <Route
                          path="apply"
                          element={
                            <LeasingStateProperty leasingStateProperty />
                          }
                        />

                        <Route
                          path="description"
                          element={<LeasingStatePropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<LeasingStatePropertyRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="renting-state-property-lands">
                        <Route
                          path="apply"
                          element={
                            <LeasingStateProperty rentingStateProperty />
                          }
                        />

                        <Route
                          path="description"
                          element={<RentingStatePropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RentingStatePropertyRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="set-limits">
                        <Route
                          path="apply-mine"
                          element={<SetLimits setLimits isOwner={true} />}
                        />
                        <Route path="apply" element={<SetLimits setLimits />} />

                        <Route
                          path="description"
                          element={<SetLimitsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<SetLimitsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="demarcation-of-a-road-on-settlement-land">
                        <Route
                          path="apply-mine"
                          element={
                            <SetLimits
                              demarcationSettlementLand
                              isOwner={true}
                            />
                          }
                        />

                        <Route
                          path="apply"
                          element={<SetLimits demarcationSettlementLand />}
                        />
                        <Route
                          path="description"
                          element={<DemarcationSettlementLandDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<DemarcationSettlementLandRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="replacement-of-settlement-road">
                        <Route
                          path="apply-mine"
                          element={
                            <SetLimits
                              replacementSettlementRoad
                              isOwner={true}
                            />
                          }
                        />
                        <Route
                          path="apply"
                          element={<SetLimits replacementSettlementRoad />}
                        />

                        <Route
                          path="description"
                          element={<ReplacementSettlementRoadDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ReplacementSettlementRoadRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="cancellation-of-a-road-on-settlement-land">
                        <Route
                          path="apply-mine"
                          element={
                            <SetLimits
                              cancellationSettlementLand
                              isOwner={true}
                            />
                          }
                        />
                        <Route
                          path="apply"
                          element={<SetLimits cancellationSettlementLand />}
                        />
                        <Route
                          path="description"
                          element={<CancellationSettlementLandDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<CancellationSettlementLandRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="providing-information-about-the-owned-property">
                        <Route
                          path="apply-mine"
                          element={
                            <SetLimits
                              providingInfoOwnedProperty
                              isOwner={true}
                            />
                          }
                        />
                        <Route
                          path="apply"
                          element={<SetLimits providingInfoOwnedProperty />}
                        />
                        <Route
                          path="description"
                          element={<ProvidingInfoOwnedPropertyDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ProvidingInfoOwnedPropertyRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="change-statement-request">
                        <Route
                          path="apply"
                          element={<ChangeStatementRequest />}
                        />
                        <Route
                          path="description"
                          element={<ChangeStatementRequestDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ChangeStatementRequestRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="providing-maps-panels-and-indexes">
                        <Route
                          path="apply"
                          element={<ProvidingMapsPanelsAndIndexes />}
                        />
                        <Route
                          path="description"
                          element={<ProvidingMapsPanelsAndIndexesDescription />}
                        />

                        <Route
                          path="requirements"
                          element={
                            <ProvidingMapsPanelsAndIndexesRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="channel-demarcation">
                        <Route path="apply" element={<ChannelDemarcation />} />
                        <Route
                          path="description"
                          element={<ChannelDemarcationDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ChannelDemarcationRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="certified-copy-of-the-border-fixing-detection-report">
                        <Route
                          path="apply"
                          element={
                            <CertifiedCopyoftheBorderFixingDetectionReport
                              certifiedCopyoftheBorderFixingDetectionReport
                            />
                          }
                        />
                        <Route
                          path="description"
                          element={
                            <CertifiedCopyoftheBorderFixingDetectionReportDescription />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <CertifiedCopyoftheBorderFixingDetectionReportRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="correct-servey-info">
                        <Route
                          path="apply"
                          element={<CorrectServeyInfo correctServeyInfo />}
                        />
                        <Route
                          path="edit"
                          element={<CorrectServeyInfo correctServeyInfo edit />}
                        />
                        <Route
                          path="description"
                          element={<CorrectServeyInfoDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<CorrectServeyInfoRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="collecting-properties-improve-appearance">
                        <Route
                          path="apply"
                          element={
                            <CollectingPropertiesImproveAppearance
                              collectingPropertiesImproveAppearance
                            />
                          }
                        />
                        <Route
                          path="description"
                          element={
                            <CollectingPropertiesImproveAppearanceDescription />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <CollectingPropertiesImproveAppearanceRequirements />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease">
                        <Route
                          path="apply"
                          element={<FinanceLease takharog />}
                        />

                        <Route
                          path="apply-mine"
                          element={<FinanceLease isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<FinanceLeaseDescription takharog />}
                        />

                        <Route
                          path="requirements"
                          element={<FinanceLeaseRequirements takharog />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease-documentaion">
                        <Route path="apply" element={<FinanceLeaseDoc />} />

                        <Route
                          path="apply-mine"
                          element={<FinanceLeaseDoc isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<FinanceLeaseDocDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<FinanceLeaseDocRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease-tenant-replace">
                        <Route
                          path="apply"
                          element={<FinanceLeaseReplace tenant />}
                        />

                        <Route
                          path="apply-mine"
                          element={
                            <FinanceLeaseReplace tenant isOwner={true} />
                          }
                        />

                        <Route
                          path="description"
                          element={<FinanceLeaseReplaceDescription tenant />}
                        />

                        <Route
                          path="requirements"
                          element={<FinanceLeaseReplaceRequirements tenant />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease-landlord-replace">
                        <Route
                          path="apply"
                          element={<FinanceLeaseReplace landlord />}
                        />

                        <Route
                          path="apply-mine"
                          element={
                            <FinanceLeaseReplace landlord isOwner={true} />
                          }
                        />

                        <Route
                          path="description"
                          element={
                            <FinanceLeaseLandLordReplaceDescription landlord />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <FinanceLeaseLandLordReplaceRequirements landlord />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease-cancel">
                        <Route
                          path="apply"
                          element={<FinanceLeaseCencel takharog />}
                        />

                        <Route
                          path="apply-mine"
                          element={<FinanceLeaseCencel isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<FinanceLeaseCencelDescription takharog />}
                        />

                        <Route
                          path="requirements"
                          element={<FinanceLeaseCencelRequirements takharog />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="financeLease-selling">
                        <Route
                          path="apply"
                          element={<FinanceLeaseSelling takharog />}
                        />

                        <Route
                          path="apply-mine"
                          element={<FinanceLeaseSelling isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<FinanceLeaseSellingDescription takharog />}
                        />

                        <Route
                          path="requirements"
                          element={<FinanceLeaseSellingRequirements takharog />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      leasing-state-property-lands-within-frontier-centers
                      <Route path="publicEndowment">
                        <Route path="apply" element={<Endowment />} />

                        <Route
                          path="apply-mine"
                          element={<Endowment isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<PublicEndowmentDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<PublicEndowmentRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="relativesEndowment">
                        <Route path="apply" element={<Endowment relatives />} />

                        <Route
                          path="apply-mine"
                          element={<Endowment relatives isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<RelativesEndowmentDescription relatives />}
                        />

                        <Route
                          path="requirements"
                          element={<RelativesEndowmentRequirements relatives />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      {categoryFallbackRoute}
                    </Route>

                    <Route path="real-estate-office">
                      <Route path="grant">
                        <Route
                          path="apply"
                          element={<RealEstateOfficeGrant />}
                        />

                        <Route
                          path="description"
                          element={<RealEstateOfficeGrantDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RealEstateOfficeGrantRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="renew">
                        <Route
                          path="apply"
                          element={<RealEstateOfficeRenew />}
                        />

                        <Route
                          path="description"
                          element={<RealEstateOfficeRenewDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RealEstateOfficeRenewRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="suspend">
                        <Route
                          path="apply"
                          element={<RealEstateOfficeSuspendCancel suspend />}
                        />

                        <Route
                          path="description"
                          element={
                            <RealEstateOfficeSuspendCancelDescription suspend />
                          }
                        />

                        <Route
                          path="requirements"
                          element={<StopRealEstateRequirements suspend />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="cancel">
                        <Route
                          path="apply"
                          element={<RealEstateOfficeSuspendCancel cancel />}
                        />

                        <Route
                          path="description"
                          element={
                            <RealEstateOfficeSuspendCancelDescription cancel />
                          }
                        />

                        <Route
                          path="requirements"
                          element={<StopRealEstateRequirements cancel />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {categoryFallbackRoute}
                    </Route>

                    <Route path="real-estate-appraiser">
                      <Route path="grant">
                        <Route
                          path="apply"
                          element={<RealEstateAppraiserGrant />}
                        />

                        <Route
                          path="description"
                          element={<RealEstateAppraiserGrantDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<RealEstateAppraiserGrantRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="renew">
                        <Route
                          path="apply"
                          element={
                            <RealEstateAppraiserRenewSuspendCancel renew />
                          }
                        />

                        <Route
                          path="description"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelDescription
                              renew
                            />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelRequirements
                              renew
                            />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="suspend">
                        <Route
                          path="apply"
                          element={
                            <RealEstateAppraiserRenewSuspendCancel suspend />
                          }
                        />

                        <Route
                          path="description"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelDescription
                              suspend
                            />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelRequirements
                              suspend
                            />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="cancel">
                        <Route
                          path="apply"
                          element={
                            <RealEstateAppraiserRenewSuspendCancel cancel />
                          }
                        />

                        <Route
                          path="description"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelDescription
                              cancel
                            />
                          }
                        />

                        <Route
                          path="requirements"
                          element={
                            <RealEstateAppraiserRenewSuspendCancelRequirements
                              cancel
                            />
                          }
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {categoryFallbackRoute}
                    </Route>

                    <Route path="surveyor">
                      <Route path="grant">
                        <Route path="apply" element={<SurveyorGrant />} />

                        <Route
                          path="description"
                          element={<SurveyorGrantDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<SurveyorGrantRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="renew">
                        <Route path="apply" element={<SurveyorRenew />} />

                        <Route
                          path="description"
                          element={<ServeyorRenewDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<ServeyorRenewRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="suspend">
                        <Route
                          path="apply"
                          element={<SurveyorSuspendCancel suspend />}
                        />

                        <Route
                          path="description"
                          element={<SurveyorSuspendCancelDescription suspend />}
                        />

                        {/* <Route path="requirements" element={<ServeyorRemoveRequirements />} /> */}

                        {serviceFallbackRoute}
                      </Route>
                      <Route path="cancel">
                        <Route
                          path="apply"
                          element={<SurveyorSuspendCancel cancel />}
                        />

                        <Route
                          path="description"
                          element={<SurveyorSuspendCancelDescription cancel />}
                        />

                        {/* <Route path="requirements" element={<ServeyorRemoveRequirements />} /> */}

                        {serviceFallbackRoute}
                      </Route>

                      {categoryFallbackRoute}
                    </Route>

                    <Route path="efraz">
                      <Route path="partner-lands">
                        <Route
                          path="apply"
                          element={<EfrazPartnersSplitJudicial partners />}
                        />
                        <Route
                          path="edit"
                          element={<EfrazPartnersSplitJudicial partners edit />}
                        />

                        <Route
                          path="description"
                          element={<EfrazPartnersLandsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazPartnersLandsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="partner-apartments">
                        <Route
                          path="apply"
                          element={
                            <EfrazPartnersSplitJudicial partners apartments />
                          }
                        />
                        <Route
                          path="edit"
                          element={
                            <EfrazPartnersSplitJudicial
                              partners
                              apartments
                              edit
                            />
                          }
                        />

                        <Route
                          path="description"
                          element={<EfrazPartnersApartmentsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazPartnersApartmentsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      {/* TAWHEED */}
                      <Route path="tawheed-lands">
                        <Route
                          path="apply"
                          element={<EfrazTawheed type="tawheed" />}
                        />
                        <Route
                          path="edit"
                          element={<EfrazTawheed type="tawheed" edit />}
                        />

                        <Route
                          path="description"
                          element={<EfrazTawheedLandsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazTawheedLandsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="tawheed-Apartments">
                        <Route
                          path="apply"
                          element={<EfrazTawheed type="tawheed" apartments />}
                        />
                        <Route
                          path="edit"
                          element={
                            <EfrazTawheed type="tawheed" apartments edit />
                          }
                        />

                        <Route
                          path="description"
                          element={<EfrazTawheedApartmentsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazTawheedApartmentsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="split-lands">
                        <Route
                          path="apply"
                          element={<EfrazPartnersSplitJudicial split />}
                        />
                        <Route
                          path="edit"
                          element={<EfrazPartnersSplitJudicial split edit />}
                        />

                        <Route
                          path="description"
                          element={<EfrazSplitLandsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazSplitLandsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="split-apartments">
                        <Route
                          path="apply"
                          element={
                            <EfrazPartnersSplitJudicial split apartments />
                          }
                        />
                        <Route
                          path="edit"
                          element={
                            <EfrazPartnersSplitJudicial split apartments edit />
                          }
                        />

                        <Route
                          path="description"
                          element={<EfrazSplitApartmentsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazSplitApartmentsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="judicial-lands">
                        <Route
                          path="apply"
                          element={<EfrazPartnersSplitJudicial judicial />}
                        />
                        <Route
                          path="edit"
                          element={<EfrazPartnersSplitJudicial judicial edit />}
                        />

                        <Route
                          path="description"
                          element={<EfrazJudicialLandsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazJudicialLandsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="judicial-apartments">
                        <Route
                          path="apply"
                          element={
                            <EfrazPartnersSplitJudicial judicial apartments />
                          }
                        />
                        <Route
                          path="edit"
                          element={
                            <EfrazPartnersSplitJudicial
                              judicial
                              apartments
                              edit
                            />
                          }
                        />

                        <Route
                          path="description"
                          element={<EfrazJudicialApartmentsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazJudicialApartmentsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="selling-lands">
                        <Route
                          path="apply"
                          element={<EfrazPartnersSplitJudicial selling />}
                        />
                        <Route
                          path="edit"
                          element={<EfrazPartnersSplitJudicial selling edit />}
                        />

                        <Route
                          path="description"
                          element={<EfrazSellingLandsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazSellingLandsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="selling-apartments">
                        <Route
                          path="apply"
                          element={
                            <EfrazPartnersSplitJudicial selling apartments />
                          }
                        />
                        <Route
                          path="edit"
                          element={
                            <EfrazPartnersSplitJudicial
                              selling
                              apartments
                              edit
                            />
                          }
                        />

                        <Route
                          path="description"
                          element={<EfrazSellingApartmentsDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<EfrazSellingApartmentsRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                    </Route>

                    <Route path="mortgage">
                      <Route path="mortgage">
                        <Route
                          path="apply-mine"
                          element={<Mortgage isOwner={true} />}
                        />

                        <Route path="apply" element={<Mortgage />} />

                        <Route
                          path="description"
                          element={<MortgageDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<MortgageRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="mortgage-release">
                        <Route path="apply" element={<MortgageRelease />} />

                        <Route
                          path="apply-mine"
                          element={<MortgageRelease isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<MortgageReleaseDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<MortgageReleaseRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>

                      <Route path="mortgage-transfer">
                        <Route path="apply" element={<MortgageTransfer />} />

                        <Route
                          path="apply-mine"
                          element={<MortgageTransfer isOwner={true} />}
                        />

                        <Route
                          path="description"
                          element={<MortgageTransferDescription />}
                        />

                        <Route
                          path="requirements"
                          element={<MortgageTransferRequirements />}
                        />

                        {serviceFallbackRoute}
                      </Route>
                      {categoryFallbackRoute}
                    </Route>

                    {generalFallbackRoute}
                  </Route>

                  {generalFallbackRoute}
                </Route>

                {generalFallbackRoute}
              </Route>
            </Route>
          </Routes>
        </Router>
      </Layout>
    </LayoutWrapper>
  );
};

export default ApplicationLayout;
